<template>
    <div>
        <vs-row class="p-4">
            <vs-col w="12" class="lineTitulo mb-2">
                <h5><strong>FAMILIARES</strong></h5>
            </vs-col>
            <vs-col sm="12" :lg="general.datos.tipo != 'prospecto' ? '6' : '12'" v-if="!deshabilitadas">
                <div class="d-flex borderCard cursor-pointer" @click="activeFamiliar =! activeFamiliar">
                    <div>
                        <vs-avatar circle size="60">
                            <img src="http://127.0.0.1:8000/img/familia.png" alt="">
                        </vs-avatar>
                    </div>
                    <div>
                        <h6><strong>FAMILIAR / TUTOR</strong></h6>
                        <p>Agregue un familiar y se creará una nueva cuenta de usuario</p>
                    </div>
                </div>
            </vs-col>
            <vs-col sm="12" lg="6" v-if="!deshabilitadas && general.datos.tipo != 'prospecto'">
                <div v-if="general.personaRol.tipoUserPrincipal != 'familiar'" class="d-flex borderCard cursor-pointer" @click="activeHermanos =! activeHermanos">
                    <div>
                        <vs-avatar circle size="60">
                            <img src="/img/familia.png" alt="">
                        </vs-avatar>
                    </div>
                    <div>
                        <h6><strong>HERMANOS</strong></h6>
                        <p>Vincular un hermano</p>
                    </div>
                </div>
            </vs-col>
            <vs-col class="mt-4" sm="12" lg="6" v-for="(fam, i) in familiares" :key="i">
                <div class="borderCard">
                    <div class="text-right" v-if="!deshabilitadas">
                        <md-chip v-if="general.datos.tutor_id === fam.id" class="mb-1 fontMedium mini-chip col-yellow" ><strong class="text-uppercase"> <i class="fas fa-bookmark fontSmall mr-2"> </i>Tutor establecido</strong></md-chip>
                        <vs-button
                            v-else
                            size="small"
                            class="ml-auto"
                            warn
                            border
                            @click="postEstablecerTutor(fam.id, general.datos)"
                        >
                            Establecer como tutor
                        </vs-button>
                    </div>
                    <div class="text-center">
                        <vs-avatar class="m-auto" circle size="80">
                            <img :src="imgParentesco(fam.parentesco)" alt="">
                        </vs-avatar>
                        <h5 class="mt-3"><strong>{{fam.apellido_paterno}} {{fam.apellido_materno}} {{fam.nombres}}</strong></h5>
                        <md-chip class="mb-1 fontMedium" :class="'mini-chip ' + parentescoAlumno(fam.parentesco)" ><strong class="text-uppercase"> {{ fam.parentesco }} </strong></md-chip>
                    </div>
                    <vs-row class="mt-4">
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.correo">
                            <p class="mb-0 breakInfo"><strong>{{fam.correo}}</strong></p>
                            <p class="mb-1"><small><i>CORREO</i></small></p>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.celular">
                            <p class="mb-0 breakInfo"><strong>{{fam.celular}}</strong></p>
                            <p class="mb-1"><small><i>CELULAR</i></small></p>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.telefono_casa">
                            <p class="mb-0 breakInfo"><strong>{{fam.telefono_casa}}</strong></p>
                            <p class="mb-1"><small><i>TELÉFONO DE CASA</i></small></p>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.el_alumno_depende">
                            <p class="mb-0 breakInfo"><strong>{{fam.el_alumno_depende}}</strong></p>
                            <p class="mb-1"><small><i>Depende el alumno</i></small></p>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.trabaja">
                            <p class="text-capitalize mb-0 breakInfo"><strong>{{fam.trabaja}}</strong></p>
                            <p class="mb-1"><small><i>TRABAJA</i></small></p>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.ocupacion">
                            <p class="text-capitalize mb-0 breakInfo"><strong>{{fam.ocupacion}}</strong></p>
                            <p class="mb-1"><small><i>OCUPACIÓN</i></small></p>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.empresa_donde_trabaja">
                            <p class="text-capitalize mb-0 breakInfo"><strong>{{fam.empresa_donde_trabaja}}</strong></p>
                            <p class="mb-1"><small><i>EMPRESA DONDE TRABAJA</i></small></p>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.telefono_trabajo">
                            <p class="text-capitalize mb-0 breakInfo"><strong>{{fam.telefono_trabajo}}</strong></p>
                            <p class="mb-1"><small><i>TELÉFONO DE TRABAJO</i></small></p>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.extension">
                            <p class="text-capitalize mb-0 breakInfo"><strong>{{fam.extension}}</strong></p>
                            <p class="mb-1"><small><i>EXTENSIÓN</i></small></p>
                        </vs-col>
                        <vs-col sm="12" lg="6" class="p-1" v-if="fam.ultimo_grado_estudios">
                            <p class="text-capitalize mb-0 breakInfo"><strong>{{fam.ultimo_grado_estudios}}</strong></p>
                            <p class="mb-1"><small><i>ÚLTIMO GRADO DE ESTUDIOS</i></small></p>
                        </vs-col>
                    </vs-row>
                    <div class="d-flex" v-if="!deshabilitadas">
                        <vs-button
                            :loading="loadingDesvincular"
                            class="ml-auto"
                            icon
                            color="danger"
                            flat
                            @click="comprobarVinculacionesExternas(fam.id), selectFamiliar = fam"
                        >
                            <i class="fas fa-unlink fontMedium mr-2"></i> Desvincular
                        </vs-button>
                        <vs-button
                            icon
                            color="success"
                            flat
                            @click="activeEditar =! activeEditar, selectFamiliar = fam"
                        >
                           <i class="fas fa-user-edit fontMedium mr-2"></i> Editar
                        </vs-button>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <agregar-familiar v-model="activeFamiliar" :general="general" @refreshComponent="getRefresh"></agregar-familiar>
        <desvincular-familiar v-model="activeDesvincular" :general="general" :vinculaciones="vinculacionesHijos" :selectFam="selectFamiliar" @refreshComponent="getRefresh"></desvincular-familiar>
        <editar-familiar v-model="activeEditar" :general="general" :vinculaciones="vinculacionesHijos" :selectFam="selectFamiliar" @refreshComponent="getRefresh"></editar-familiar>
        <vincular-hermano v-model="activeHermanos" :general="general"></vincular-hermano>
    </div>
</template>
<script>
import alumnos from '../../../../../api/requests/alumno'
import AgregarFamiliar from './modales/vincular-familiares.vue'
import DesvincularFamiliar from './modales/desvincular.vue'
import EditarFamiliar from './modales/editar-familiar.vue'
import VincularHermano from './modales/vincular-hermanos.vue'
export default {
    props: [
        'general',
        'personaRol'
    ],
    data(){
        return{
            info: {},
            activeFamiliar: false,
            activeDesvincular: false,
            activeEditar: false,
            activeHermanos: false, 
            familiares: [],
            selectFamiliar: [],
            vinculacionesHijos: {},
            loadingDesvincular: false,
            deshabilitadas: true
        }
    },
    components:{
        AgregarFamiliar,
        DesvincularFamiliar,
        EditarFamiliar,
        VincularHermano
    },
    methods: {
        deshabilitadasOpciones(){
            if(this.general.personaRol.tipoUserPrincipal != 'Personal central - TI'){
                if((this.general.personaRol.tipoUserPrincipal != 'alumno' || ([5, 25, 28].includes(this.general.datos.institucionId)))){
                    if((this.general.permisos.includes('familiares-visualizacion'))){
                        this.deshabilitadas = true
                    }else{
                        this.deshabilitadas = false
                    }
                }else{
                this.deshabilitadas = true
            }
            }else{
                this.deshabilitadas = false
            }
        },
        // getInfo(){
        //     if(this.general.datos.datos_referenciales)
        //     const {matricula_sim, matricula_referencial, prom_primer_ingreso, clave_docente} = this.general.datos.datos_referenciales
        //     this.info = {matricula_sim, matricula_referencial, prom_primer_ingreso, clave_docente}
        // },
        parentescoAlumno(parentesco){
            if(parentesco == 'padre'){
                return 'col-blue'
            }
            if(parentesco == 'madre'){
                return 'col-red'
            }
        },
        imgParentesco(parentesco){
            if(parentesco == 'madre'){
                return '/img/avatar-mujer.png'
            }else{
                return '/img/avatar-hombre.png'
            }
        },
        getRefresh(idPersonal){
            this.$emit('refreshComponent', idPersonal, this.general.datos.tipo != 'prospecto' ? 'alumno' : 'seguimiento')
        },
        async postEstablecerTutor(familiar){
            // general.datos.persona_id, general.datos.prospecto_id
            const loading = this.$vs.loading()
            const tipo = this.general.datos.tipo
            const prospecto = this.general.datos.id
            const persona = this.general.datos.persona_id
            try{
                const params = {
                    familiar_id: familiar,
                    persona_id: persona ? persona : null
                }
                if(prospecto == 'prospecto'){
                    params.prospecto_id = this.general.datos.id
                }else{
                    params.prospecto_id = this.general.datos.prospecto_id
                }
                const response = await alumnos.postEstablecerTutor(params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    duration: 5000,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: 'Se estableció como tutor a ' + response.data.nombre
                })
                this.getRefresh(tipo != 'prospecto' ? persona : prospecto)
                loading.close()
            }catch(error){
                console.log(error)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Algo salio mal',
                    text: 'Favor de ponerse en contacto con el administrador'
                })
                loading.close()
            }
        },
        async comprobarVinculacionesExternas(familiar){
            try{
                this.loadingDesvincular = true
                const {data: response} = await alumnos.comprobarVinculacionesExternas(familiar)
                this.vinculacionesHijos = response
                this.activeDesvincular =! this.activeDesvincular
                this.loadingDesvincular = false
            }catch{

            }
        },
    },
    watch:{
        general(){
            // this.getInfo()
            this.familiares = this.general.datos.familiares
            this.deshabilitadasOpciones()
        },
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
.borderCard{
    width: 95%;
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 .125rem .25rem rgba(0,0,0,.3)!important;
}
.cursor-pointer{
    cursor: pointer;
}
</style>

<style lang="scss" scoped >
@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('blue', #2d8bf6, #c7e1ff ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);  
    @include text-colors ('blue', #2d8bf6, #c7e1ff ); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236) );
}

.col-purple{
    color: purple;
    background: rgb(232, 218, 239);
}
.fontBiger{
    font-size: 22px;
}
.fontBig{
    font-size: 16px;
}
.fontMedium{
    font-size: 15px;
}

.fontSmall{
    font-size: 12px;
}

.breakInfo{
    word-break: break-all;
}

</style>